
<template>
<b-container class="bv-example-cambiocmn">
        <b-img class="logooc" :src="logo"></b-img>
         <b-card  style="max-width: 23rem;" class="mb-222" >
         <b-img class="iconomodalnoti" :src="imgen"></b-img>
           <b-card-title>
              <div class="ingreso-al-sistema-prmmm poppins-semi-bold-mine-shaft-20px">{{message}}</div>
            </b-card-title>
         <div @click="$router.push(actions)">
            <b-button block class="boton-ingresoo"  ><label  class="ingresar poppins-semi-bold-white-14px">{{massageboton}}</label></b-button>
            </div>
         </b-card>
</b-container>
  
</template>

<script>

export default {
  name: "ModalGeneral",
  components: {},
  
  props: [
    "logo",
    "imgen",
  ],
  data() {
        return {
            message:"",
            actions:"",
            massageboton:"",
        }
    },
    async created() {
          this.message=this.$route.params.message;
          this.actions=this.$route.params.actions;
          this.massageboton=this.$route.params.massageboton;
    }
};
</script>

<style>
.bv-example-cambiocmn {
    background-color: var(--blue-violet);
    margin: 0;
    max-width: 100% !important;
    height: 753px !important;
    text-align: center;
}
.logooc {
    margin-top: 3%;
}
.iconomodalnoti {
    margin-top: 10%;
}
.mb-222 {
    margin-left: 39%;
    padding: 2% 2%;
      line-height: 14px;
      background-color: var(--zircon) !important;
    border-radius: 10px !important;
    margin-top: 4%;
    border-color:transparent !important ;
}
.ingreso-al-sistema-prmmm { 
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;
  margin-top:18%;
  margin-bottom:18%;
 
}
@media (max-width: 1922px) {
.bv-example-cambiocmn {
    height: 969px !important;
}
.mb-222 {
    margin-left: 41%;
}
}
@media (max-width: 1540px) {
.bv-example-cambiocmn {
    height: 753px !important;
}
.mb-222 {
   margin-left: 37%;
}
}
@media (max-width: 1280px) {
    .bv-example-cambiocmn {
    height: 609px !important;
}
.mb-222 {
    margin-left: 36%;
    margin-top: 4%;
}
}
@media (max-width: 1100px) {
    .bv-example-cambiocmn {
    height: 507px !important;
}
 .logooc {
    margin-top: 3%;
    width: 23%;
 }
.mb-222 {
    margin-left: 33%;
    margin-top: 3%;
}
.iconomodalnoti {
    margin-top: 2%;
}
.ingreso-al-sistema-prmmm {
    margin-top: 12%;
    margin-bottom: 12%;
}
}
</style>